import { render, staticRenderFns } from "./VerificationUpload.vue?vue&type=template&id=796da723&scoped=true&"
import script from "./VerificationUpload.vue?vue&type=script&lang=js&"
export * from "./VerificationUpload.vue?vue&type=script&lang=js&"
import style0 from "./VerificationUpload.vue?vue&type=style&index=0&id=796da723&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796da723",
  null
  
)

export default component.exports